import { Ribbon } from "lucide-react";

// Visible uniquement en octobre, disparaît automatiquement le 1er novembre
export const OctobreRose = () => {
  if (new Date().getMonth() !== 9) return null;
  return (
    <div data-testid="octobre-rose-banner" className="relative z-50 bg-[#E8418C] text-white">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center text-xs font-semibold sm:text-sm">
        <Ribbon className="h-5 w-5 shrink-0 fill-white/30" aria-hidden="true" />
        <span>Octobre Rose — Conciergerie Familly 29 soutient la lutte contre le cancer du sein. Pensez au dépistage !</span>
        <Ribbon className="hidden h-5 w-5 shrink-0 fill-white/30 sm:block" aria-hidden="true" />
      </div>
    </div>
  );
};
